module.exports = __webpack_public_path__ + "static/media/User.6652d70e.svg";